var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.organisation.latestLicenceValidOnYear)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('AppChip',_vm._g(_vm._b({attrs:{"color":_vm.chipColor,"text-color":"white--text","data-test":"licenceStatusBadge"}},'AppChip',attrs,false),on),[_vm._v(_vm._s(_vm.organisation.latestLicenceValidOnYear))])]}}],null,false,3422727092)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(
      "organisations:membership.licence.lastIssuedLicence.tooltip",
      "Last issued licence"
    )))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }